import { WorkingConditionDisplayItemProps } from 'modules/contracts_settings/lib/useWorkConditionItemsCategories'

import CategoricalDataItem from './CategoricalDataItem'
import WorkingConditionItemCentsField from './CentsField'
import WorkingConditionItemTextField from './TextField'
import WorkingConditionItemToogler from './Toggler'

const WorkingConditionItem = (item: WorkingConditionDisplayItemProps) => {
  switch (item.type) {
    case 'boolean':
      return <WorkingConditionItemToogler {...item} />
    case 'cents':
      return <WorkingConditionItemCentsField {...item} />
    case 'string':
      if (item.allowedValues) {
        return <CategoricalDataItem {...item} />
      }
      return <WorkingConditionItemTextField {...item} />
    default:
      return <WorkingConditionItemTextField {...item} />
  }
}

export default WorkingConditionItem
